import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Courses } from "./components/site/Courses";
import { AdultCourses } from "./components/site/AdultCourses";
import { PrivateLessons } from "./components/site/PrivateLessons";
import { Benefits } from "./components/site/Benefits";
import { Journey } from "./components/site/Journey";
import { About } from "./components/site/About";
import { Booking } from "./components/site/Booking";
import { Locations } from "./components/site/Locations";
import { Faq } from "./components/site/Faq";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { MobileBar } from "./components/site/MobileBar";
import { LegalPage, LEGAL_PAGES } from "./components/site/LegalPage";
import DieburgPage from "./components/site/DieburgPage";
import NotFound from "./components/site/NotFound";
import { Seo } from "./components/site/Seo";
import { scrollToId } from "./lib/scroll";

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
};

const Landing = () => {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return undefined;
    const t = setTimeout(() => scrollToId(id), 400);
    return () => clearTimeout(t);
  }, []);
  return (
    <>
      <Seo
        title="Schwimmkurse für Kinder in Dieburg | Schwimmschule Manta"
        description="Schwimmschule Manta im Sportbad Dieburg: Froschkurs ab 3,5 Jahren, Seepferdchenkurs, Seeräuber & Bronze sowie Kurse für Erwachsene – für Dieburg & Darmstadt."
        path="/"
      />
      <main id="main">
        <Hero />
        <Courses />
        <AdultCourses />
        <PrivateLessons />
        <Benefits />
        <Journey />
        <About />
        <Booking />
        <Locations />
        <Faq />
        <Contact />
      </main>
      <MobileBar />
    </>
  );
};

export default function App() {
  useLenis();
  return (
    <BrowserRouter>
      <div className="App overflow-x-clip">
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-navy">
          Zum Inhalt springen
        </a>
        <Nav />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/schwimmkurse-dieburg" element={<DieburgPage />} />
          {LEGAL_PAGES.map((p) => (
            <Route key={p.path} path={p.path} element={<LegalPage page={p} />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
